import { AutocompleteProvider } from "../../types/enums";
import { GoogleMapsLoader } from "../maps/google/google-maps-loader";
import { IGeoSearchProvider } from "./geo-search-provider.interface";
import { GoogleGeoSearchProvider } from "./google/google-geo-search-provider";
import { HereGeoSearchProvider } from "./here/here-geo-search-provider";
import { NoneGeoSearchProvider } from "./none/none-geo-search-provider";

export class GeoSearchProviderFactory {
    static getGeoSearchProvider(mapProviderId: AutocompleteProvider, apiKey?: string): IGeoSearchProvider {
        switch (mapProviderId) {
            case AutocompleteProvider.GOOGLE: {
                if (!apiKey)
                    return new NoneGeoSearchProvider();
                const loader = GoogleMapsLoader.getLoader(apiKey);
                return new GoogleGeoSearchProvider(loader);
            }
            case AutocompleteProvider.HERE:
                if (!apiKey)
                    return new NoneGeoSearchProvider();
                return new HereGeoSearchProvider(apiKey);
            default:
                return new NoneGeoSearchProvider();
        }
    }
}